export const openGroupModal = () => ({
  type: "SET_GROUP_MODAL_OPEN",
});

export const closeGroupModal = () => ({
  type: "SET_GROUP_MODAL_CLOSE",
});
